const CardData = [
  {
    name: "Inventory Turnover Ratio",
    value: 1.2,
  },
  {
    name: "Average Inventory",
    value: "$341,678",
  },
  {
    name: "Cost of Goods Sold",
    value: "$412,343",
  },
  {
    name: "Service Level",
    value: "95%",
  },
  {
    name: "Days to Sell Inventory",
    value: 16.5,
  },
  {
    name: "Lead Time",
    value: 14.2,
  },
  {
    name: "Perfect Order Rate",
    value: "94.5%",
  },
  {
    name: "Rate of Return",
    value: "2.3%",
  },
];

export default CardData;
